import constants from '../utils/constants'

export default {
  get (API_KEY, self, params = {}) {
    try {
      return http.get(`${constants.API_URL}/api/${API_KEY}${this.getParams(params)}`).then(response => {
        return {
          success: 200,
          data: response.data
        }
      }).catch(error => {
        const errorMessage = (error && error.response && error.response.data.message) || error.message
        return {
          success: 99,
          message: errorMessage
        }
      })
    } catch (error) {
      const errorMessage = (error && error.response && error.response.data.message) || error.message
      return {
        success: 99,
        message: errorMessage
      }
    } finally {

    }
  },
  post (API_KEY, self, formdata) {
    try {
      return http.post(`${constants.API_URL}/api/${API_KEY}`, formdata).then(response => {
        return {
          success: 200,
          data: response.data
        }
      }).catch(error => {
        const errorMessage = (error && error.response && error.response.data.message) || error.message
        return {
          success: 99,
          message: errorMessage
        }
      })
    } catch (error) {
      const errorMessage = (error && error.response && error.response.data.message) || error.message
      return {
        success: 99,
        message: errorMessage
      }
    } finally {

    }
  },
  put (API_KEY, self, id, formdata) {
    try {
      return http.put(`${constants.API_URL}/api/${API_KEY}/${id}`, formdata).then(response => {
        return {
          success: 200,
          data: response.data
        }
      }).catch(error => {
        const errorMessage = (error && error.response && error.response.data.message) || error.message
        return {
          success: 99,
          message: errorMessage
        }
      })
    } catch (error) {
      const errorMessage = (error && error.response && error.response.data.message) || error.message
      return {
        success: 99,
        message: errorMessage
      }
    } finally {

    }
  },
  // helper
  getParams (obj) {
    let str = ''

    for (let key in obj) {
      if (str !== '') {
        str += '&'
      }
      str += key + '=' + obj[key]
    }

    return str ? '?' + str : ''
  }
}
